import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';

const templateUrl = require('./siteDetail.html');

class SiteDetailController extends ComponentController {
  site: any;
  manufacturers: any[];
  canDelete: boolean;
  timeZones: any[] = [
    { id: 'US/Eastern', name: 'US/Eastern' },
    { id: 'US/Central', name: 'US/Central' },
    { id: 'US/Mountain', name: 'US/Mountain' },
    { id: 'US/Pacific', name: 'US/Pacific' },
    { id: 'US/Alaska', name: 'US/Alaska' },
    { id: 'US/Hawaii', name: 'US/Hawaii' },
    { id: 'UTC', name: 'UTC' }
  ];

  constructor(
    private $state: any,
    private SiteService: any,
    private AuthService: any,
    private uibModal: any,
    private SiteSwitcherService: any
  ) {
    super();
  }

  $onInit = () => {
    if (_.isNil(_.get(this.site, 'manufacturer.id'))) {
      this.site.manufacturer.id = this.manufacturers[0].id;
    }
    this.canDelete = this.site.id && this.AuthService.hasPermission('Site', 'delete');
  };

  saveSite = isValid => {
    if (isValid) {
      this.SiteService.save(this.site).then(() => {
        this.SiteSwitcherService.resetAllSites().then(() => {
          this.goToSites();
        });
      });
    }
  };

  deleteResource = () => {
    this.SiteService.delete(this.site).then(() => {
      this.goToSites();
    });
  };

  goToSites = () => {
    this.$state.go('admin.sites');
  };

  confirmDelete = () => {
    this._confirmDelete(this.uibModal, this.site, this.site.name);
  };

  getManufacturerName = () => {
    var manufacturer = _.find(this.manufacturers, { id: this.site.manufacturer.id });
    return manufacturer ? manufacturer.name : '';
  };
}

angular.module('ciApp').component('siteDetail', {
  templateUrl: templateUrl,
  bindings: {
    site: '<',
    manufacturers: '<'
  },
  controller: [
    '$state',
    'SiteService',
    'AuthService',
    '$uibModal',
    'SiteSwitcherService',
    SiteDetailController
  ]
});



// WEBPACK FOOTER //
// ./app/admin/sites/siteDetail.component.ts